<template>
    <div v-show="storeResource.total_resources > 0">
        <headline :title="lang($t(storeResource.table_heading))"></headline>

        <!--resources table-->
      <mq-layout mq="wide">
          <div>
              <div class="content-wrapper resources"
                   v-for="(resources, table_key) in storeResource.cate_list"
                   v-show="storeResource.total_resources > 0"
              >
                  <h3 class="title-head">{{ resources.heading }}</h3>

                  <div class="obj-resources-table">
                      <!--thead-->
                      <SubCateListTableHeading
                              v-bind:table_key="table_key"
                      ></SubCateListTableHeading>
                      <!--tbody-->
                      <ResourceListItem
                              v-bind:cate_list="resources.resource"
                      ></ResourceListItem>
                      <!---end tbody-->
                  </div>

              </div>
          </div>
      </mq-layout>
      <mq-layout mq="narrow">
          <div>
              <div class="content-wrapper resources"
                   v-for="(resources, table_key) in storeResource.cate_list"
                   v-show="storeResource.total_resources > 0"
              >
                  <h3 class="title-head">{{ resources.heading }}</h3>

                  <div class="obj-resources-table">
                      <!--thead-->
                      <SubCateListTableHeading
                              v-bind:table_key="table_key"
                      ></SubCateListTableHeading>
                      <!--tbody-->
                      <ResourceListItem
                              v-bind:cate_list="resources.resource"
                      ></ResourceListItem>
                      <!---end tbody-->
                  </div>

              </div>
          </div>
      </mq-layout>
    <!--end resources table-->

    </div>
</template>

<script>

    import {common} from "@mixins/common";
    import {storeMapper} from '@mixins/storeMapper';
    import api from '@js/api';
    import SubCateListTableHeading from '@/SubCateListTableHeading';
    import ResourceListItem from '@/ResourceListItem';
    import EventBus from '@common/eventBus';

    export default {
        name: "LatestNews",
        mixins:[
            common,
            storeMapper
        ],
        components: {
            SubCateListTableHeading,
            ResourceListItem
        },
        data() {
          return {
              cate_list: [],
              total_resources: 0
          }
        },
        beforeRouteUpdate (to, from, next) {
            next();
            this.fetchData();
        },
        /**路由相處理
         * 第一次進入本頁面時的動作。
         * @param to
         * @param from
         * @param next
         */
        beforeRouteEnter (to, from, next) {

            //Note in this route guard, access 'this' using vm (e.g. vm.fetchData() will trigger this.fetchData()
            next(vm=> {

                EventBus.$emit("showGlobalLoading");
                vm.fetchData();
            });
        },
        methods: {
            fetchData() {
                let self = this;
                api.getHkepNews().then(resp=> {

                    self.$store.commit("resource_store/setCateData", {
                        cate_title: resp.data.col_title,
                        cate_list: resp.data.resources,
                        table_heading: (resp.data.table_heading)? resp.data.table_heading: "Latest News",
                        total_resources: resp.data.count,
                        content_type:resp.data.content_type,
                        mobile_order: resp.data.mobile_order,
                        filter: resp.data.filter,
                        download_display_type: resp.data.download_display_type

                    });
                    EventBus.$emit("hideGlobalLoading");

                }).catch(function (error) {
                    EventBus.$emit("hideGlobalLoading");
                    //catch 之後的 then(), 無論 axios 成功或是失敗, 總會執行
                });
            },
            listenEvents()
            {
                EventBus.$on("refreshNews", ()=>{
                    this.refreshNews();
                });
            },
            refreshNews()
            {
                this.fetchData();
            }
        },
        mounted() {
            this.fetchData();
            this.listenEvents();
        }
    }
</script>

<style scoped lang="scss">

    @import "~@sass/_variables.scss";
    @import "~@sass/_mixins.scss";

    .content-wrapper.resources {
        padding-left: 0;
        padding-right: 0;
    }

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/NswNews.vue